import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { DropDownKeywords } from 'src/app/models/shared/dropdown-option';
import { UserRole } from 'src/app/models/security/user-role-enum';
import { AuthService } from 'src/app/services/auth.service';
import { DropdownService } from 'src/app/services/dropdown.service';

interface MenuItem {
  name: string;
  icon: string;
  route: string;
  action?: () => void;
  roles?: UserRole[];
  showWhenLoggedOut?: boolean;
}

interface MenuSection {
  title?: string;
  mainRoute?: string;
  items: MenuItem[];
  roles?: UserRole[];
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styles: [],
  standalone: true,
  imports: [CommonModule, RouterLink]
})
export class MenuComponent implements OnInit {

  authService = inject(AuthService);
  dropdownService = inject(DropdownService);

  currentRole: string | null = '';
  quickFilters: any[] = [];

  menuSections: MenuSection[] = [
    {
      items: [
        {
          name: 'Inicio',
          icon: 'fa-solid fa-house',
          route: '/candidates/main-comparison',
          roles: [UserRole.Member]
        },
        {
          name: 'Acerca de nosotros',
          icon: 'fa-regular fa-building',
          route: '/home/about',
        },
        {
          name: 'Profesionales',
          icon: 'fa-solid fa-user-tie',
          route: '/home/freelancer',
        },
        {
          name: 'Servicios',
          icon: 'fa-solid fa-handshake',
          route: '/home/available-services',
          roles: [UserRole.Member, UserRole.Company],
          showWhenLoggedOut: true
        },
        {
          name: 'Productos',
          icon: 'fa-solid fa-boxes-stacked',
          route: '/home/products',
          roles: [UserRole.Member, UserRole.Company],
          showWhenLoggedOut: true
        }
      ]
    },
    {
      title: 'Administrador',
      mainRoute: '',
      roles: [UserRole.Admin],
      items: [
        {
          name: 'Inicio',
          icon: 'fa-solid fa-house',
          route: '/admin/main',
          roles: [UserRole.Admin]
        },
        {
          name: 'Estadísticas',
          icon: 'fa-solid fa-chart-pie',
          route: '/statistics/main',
          roles: [UserRole.Admin]
        },
        {
          name: 'Aprobación de solicitudes',
          icon: 'fa-solid fa-clipboard-check',
          route: '/admin/approve-requests',
          roles: [UserRole.Admin]
        },
        {
          name: 'Mi Cuenta',
          icon: 'fa-solid fa-id-card-clip',
          route: '/admin/my-account',
          roles: [UserRole.Admin]
        }
      ]
    },
    {
      title: 'Mantenimientos',
      mainRoute: '',
      roles: [UserRole.Admin],
      items: [
        {
          name: 'Compañias',
          icon: 'fa-regular fa-building',
          route: '/admin/companies',
          roles: [UserRole.Admin]
        },
        {
          name: 'Candidatos',
          icon: 'fa-solid fa-user-tie',
          route: '/admin/candidates',
          roles: [UserRole.Admin]
        },
        {
          name: 'Usuarios',
          icon: 'fa-solid fa-users',
          route: '/admin/users',
          roles: [UserRole.Admin]
        },
        {
          name: 'Catálogo Servicos/Productos',
          icon: 'fa-solid fa-boxes-stacked',
          route: '/admin/catalog-items',
          roles: [UserRole.Admin]
        },
        //   icon: 'fa-solid fa-table',
        //   route: '/admin/catalogs',
        //   roles: [UserRole.Admin] 
        // },
        {
          name: 'Paises',
          icon: 'fa-solid fa-table',
          route: '/admin/country',
          roles: [UserRole.Admin]
        },
        {
          name: 'Provincias',
          icon: 'fa-solid fa-table',
          route: '/admin/state',
          roles: [UserRole.Admin]
        },
        {
          name: 'Municipios',
          icon: 'fa-solid fa-table',
          route: '/admin/cities',
          roles: [UserRole.Admin]
        },
        {
          name: 'Parámetros Financieros',
          icon: 'fa-solid fa-coins',
          route: '/admin/financial-parameters',
          roles: [UserRole.Admin]
        },
        {
          name: 'Certificaciones',
          icon: 'fa-solid fa-table',
          route: '/admin/certifications',
          roles: [UserRole.Admin]
        },
        {
          name: 'Niveles Formativos',
          icon: 'fa-solid fa-table',
          route: '/admin/educationlevels',
          roles: [UserRole.Admin]
        },
        {
          name: 'Tipos de Contratos',
          icon: 'fa-solid fa-table',
          route: '/admin/contracttypes',
          roles: [UserRole.Admin]
        },
        {
          name: 'Niveles de Experiencia',
          icon: 'fa-solid fa-table',
          route: '/admin/experiencelevels',
          roles: [UserRole.Admin]
        },
        {
          name: 'Sexos',
          icon: 'fa-solid fa-table',
          route: '/admin/sex',
          roles: [UserRole.Admin]
        },
        {
          name: 'Idiomas',
          icon: 'fa-solid fa-table',
          route: '/admin/languages',
          roles: [UserRole.Admin]
        },
        {
          name: 'Niveles de Idiomas',
          icon: 'fa-solid fa-table',
          route: '/admin/languagelevels',
          roles: [UserRole.Admin]
        },
        {
          name: 'Habilidades',
          icon: 'fa-solid fa-table',
          route: '/admin/skills',
          roles: [UserRole.Admin]
        },
        {
          name: 'Niveles de Habilidades',
          icon: 'fa-solid fa-table',
          route: '/admin/skilllevels',
          roles: [UserRole.Admin]
        },
        {
          name: 'Tipos de Documentos de identidad',
          icon: 'fa-solid fa-table',
          route: '/admin/identitytypes',
          roles: [UserRole.Admin]
        },
        {
          name: 'Honores',
          icon: 'fa-solid fa-table',
          route: '/admin/honors',
          roles: [UserRole.Admin]
        },
        {
          name: 'Carrusel',
          icon: 'fa-solid fa-table',
          route: '/admin/carouselsadmin',
          roles: [UserRole.Admin]
        },
        {
          name: 'Actividades Económicas',
          icon: 'fa-solid fa-table',
          route: '/admin/economicactivities',
          roles: [UserRole.Admin]
        },
        {
          name: 'Perfiles Profesionales',
          icon: 'fa-solid fa-table',
          route: '/admin/professionalprofiles',
          roles: [UserRole.Admin]
        }

      ]
    },
    {
      title: 'Candidato',
      mainRoute: '/candidates/main',
      roles: [UserRole.Member],
      items: [
        {
          name: 'Mis Curriculum',
          icon: 'fa-regular fa-address-card',
          route: '/candidates/my-cvs',
          roles: [UserRole.Member]
        },
        {
          name: 'Ofertas laborales',
          icon: 'fa-solid fa-briefcase',
          route: '/candidates/job-offers',
          roles: [UserRole.Member]
        },
        {
          name: 'Mi Cuenta',
          icon: 'fa-solid fa-id-card-clip',
          route: '/candidates/my-account',
          roles: [UserRole.Member]
        }
      ]
    },
    {
      title: 'Reclutador',
      mainRoute: '/companies/main',
      roles: [UserRole.Company],
      items: [
        {
          name: 'Ofertas laborales',
          icon: 'fa-solid fa-briefcase',
          route: '/companies/job-offers',
          roles: [UserRole.Company]
        },
        {
          name: 'Crear oferta',
          icon: 'fa-solid fa-plus-square',
          route: '/companies/create-job-offer',
          roles: [UserRole.Company]
        },
        {
          name: 'Mi Cuenta',
          icon: 'fa-solid fa-id-card-clip',
          route: '/companies/my-account',
          roles: [UserRole.Company]
        }
      ]
    }
  ];

  searchValue: string = '';

  router = inject(Router);

  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchValue = input.value;
  }

  onSearchEnter(): void {
    const queryParams: any = {};
    queryParams.search = this.searchValue;
    this.router.navigate(['/home/search'], { queryParams });
  }

  ngOnInit(): void {
    this.currentRole = this.authService.getUserRoleId();
    this.loadQuickFilters();
  }

  loadQuickFilters(): void {
    this.dropdownService.GetOptions(DropDownKeywords.QuickFilters, null, undefined, true).subscribe({
      next: (filters) => {
        this.quickFilters = filters;
        console.log('[QuickFilters] Filtros rápidos cargados:', filters);
      },
      error: (err) => {
        console.error('[QuickFilters] Error al cargar filtros rápidos:', err);
      }
    });
  }

  isAllowed(roles?: any): boolean {
    if (!roles) {
      return true;
    }

    const userRole = this.authService.getUserRoleId();
    if (!userRole) {
      return false;
    } else {
      return roles?.includes(userRole);
    }
  }

  toggleMenu(): void {
    const appMain = document.getElementById('app-main');
    if (appMain) appMain.classList.toggle('open-menu');
  }

  handleItemClick(item: MenuItem): void {
    this.toggleMenu();
    if (item.action) item.action();
  }

  navigateToFilter(filter: any): void {
    // Cerrar el menú
    this.toggleMenu();

    // Navegar a la ruta especificada en el código del filtro
    // El código del filtro debe ser una ruta válida como '/home/search?departmentId=1'
    if (filter && filter.code) {
      console.log(`[QuickFilters] Navegando a: ${filter.code}`);
      this.router.navigateByUrl(filter.code);
    }
  }
}